import { SvgIconType } from './svg.interface';

const HomePage: SvgIconType = ({
  width = 32,
  height = 32,
  className = '',
  color = '#0D7EB7'
}) => (
  <svg
    width={width}
    height={height}
    className={className}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="32" height="32" rx="6" fill={color} />
    <path
      d="M8.9719 13.9996L16 10.0001L23.0281 13.9996C23.4161 13.9871 23.7634 13.7526 23.9178 13.3958C24.1372 12.8885 23.9022 12.3002 23.3929 12.0817L16.3972 8.0805C16.1436 7.9717 15.8562 7.9717 15.6026 8.0805L8.60688 12.0817C8.23859 12.2397 8 12.6008 8 13.0001C8 13.5416 8.43224 13.9826 8.9719 13.9996Z"
      fill="white"
    />
    <path
      d="M16 11.726L9.5 15.4249V22.9989C9.5 23.5512 9.94772 23.9989 10.5 23.9989H14V18.9989C14 18.4466 14.4477 17.9989 15 17.9989H17C17.5523 17.9989 18 18.4466 18 18.9989V23.9989H21.5C22.0523 23.9989 22.5 23.5512 22.5 22.9989V15.425L16 11.726Z"
      fill="white"
    />
  </svg>
);

export default HomePage;
